<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="atlas-fraud-document-report-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">Document report</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body fraud-document-report-body">
        <div class="fraud-document-report-shell">
          <section class="report-hero">
            <div class="report-file-name">{{ documentAnalysis.file_name || '-' }}</div>
            <div class="report-summary">{{ documentAnalysis.summary || 'No summary returned.' }}</div>
          </section>

          <section class="report-card">
            <div class="report-grid">
              <div class="report-field">
                <div class="report-label">Tags</div>
                <div class="report-value">{{ tags }}</div>
              </div>
              <div class="report-field">
                <div class="report-label">Format</div>
                <div class="report-value">{{ documentAnalysis.format || '-' }}</div>
              </div>
              <div class="report-field">
                <div class="report-label">Size</div>
                <div class="report-value">{{ size }}</div>
              </div>
              <div class="report-field">
                <div class="report-label">Origin hint</div>
                <div class="report-value">{{ documentAnalysis.origin_hint || '-' }}</div>
              </div>
            </div>
          </section>

          <section *ngIf="documentAnalysis.errors?.length" class="report-card report-card-warning">
            <div class="report-section-title">Errors</div>
            <div class="report-error-list">
              <div *ngFor="let error of documentAnalysis.errors" class="report-error">{{ error }}</div>
            </div>
          </section>

          <section *ngIf="hasObjectValue(documentAnalysis.ai_assessment)" class="report-card">
            <div class="report-section-title">AI assessment</div>
            <pre>{{ formatObject(documentAnalysis.ai_assessment) }}</pre>
          </section>

          <section *ngIf="hasObjectValue(documentAnalysis.edit_assessment)" class="report-card">
            <div class="report-section-title">Edit assessment</div>
            <pre>{{ formatObject(documentAnalysis.edit_assessment) }}</pre>
          </section>

          <section *ngIf="hasObjectValue(documentAnalysis.analysis)" class="report-card">
            <div class="report-section-title">Analysis</div>
            <pre>{{ formatObject(documentAnalysis.analysis) }}</pre>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
